(function () {
    'use strict';

    angular.module("imApp").factory("labourSalaryTypeService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 1423,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 1424,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
